'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var React = require('react');
var TitleSection = require('../common/title-section');
var BodySection = require('../common/body-section');
var CTASection = require('../common/cta-section');

module.exports = React.createClass({
    displayName: 'Free Esignature Tool SEO Page',

    renderTitleSection: function renderTitleSection() {
        var titleSectionProps = {
            title: 'Free eSignature Tool',
            subtitle: 'It\'s simple to start signing for free! Create your HelloSign account and start signing.',
            buttonText: 'SIGN ME UP!'
        };
        return React.createElement(TitleSection, _extends({}, titleSectionProps, this.props));
    },
    renderBodySection: function renderBodySection() {
        var headerClass = 'm-marketing-page--header';
        return React.createElement(
            BodySection,
            null,
            React.createElement(
                'h2',
                { className: headerClass },
                'What is HelloSign?'
            ),
            React.createElement(
                'p',
                null,
                'HelloSign is a desktop and device-friendly app allows you to complete paperwork online. Our technology is compliant with current eSignature laws and our bank-level security ensures a secure way to sign your paperwork online. We\u2019ve been around since 2010 and have been growing fast over the past few years!'
            ),
            React.createElement(
                'h2',
                { className: headerClass },
                'How many free documents do I get per month with HelloSign?'
            ),
            React.createElement(
                'p',
                null,
                'You get 3 free documents per month when you sign up for the free HelloSign plan. Your account is automatically refilled each month. Unused documents don\u2019t rollover .'
            ),
            React.createElement(
                'h2',
                { className: headerClass },
                'What\u2019s included in the next plan up?'
            ),
            React.createElement(
                'p',
                null,
                'Any Pro plan or above includes unlimited documents and access to HelloSign templates. You\u2019ll also have access to ',
                React.createElement(
                    'a',
                    {
                        href: 'https://www.hellosign.com/info/demo-data-validation',
                        target: '_blank', rel: 'noopener noreferrer' },
                    'data validation'
                ),
                ', a tool that helps you to prevent signer error by setting rules for your text fields. There are also plans for teams for cross-team document tracking and to make sure everyone on your team is always sending out the latest version.'
            ),
            React.createElement(
                'p',
                null,
                'You can learn more about the plans by ',
                React.createElement(
                    'a',
                    {
                        href: 'https://app.hellosign.com/info/pricing', target: '_blank', rel: 'noopener noreferrer' },
                    'visiting the pricing plan here.'
                )
            ),
            React.createElement(
                'h2',
                { className: headerClass },
                'Is it legal to sign documents online using HelloSign?'
            ),
            React.createElement(
                'p',
                null,
                'Yes! It\u2019s legal to sign documents online using HelloSign\u2019s free eSignature tool. In fact, it\u2019s also a more secure way to keep track of your documents. Audit trails are attached to each document giving you a clear look at the journey of your doc. Audit trails log each time a person interacts with a document and timestamps these events.'
            ),
            React.createElement(
                'h2',
                { className: headerClass },
                'How do I sign documents online?'
            ),
            React.createElement(
                'p',
                null,
                'It\u2019s easy to start signing with HelloSign! You can create a free account by linking your Google login or entering in your email here. Once you\u2019ve created your free account, you\u2019re ready to start sending. Simply upload the document you\u2019d like signed, format it using signature or text fields, and send the signature request! You can also upload documents sent to you that require a signature and insert your own signature.'
            )
        );
    },
    renderCTASection: function renderCTASection() {
        var ctaSectionProps = {
            title: 'Get Started',
            subtitle: 'Whatcha waiting for? Let’s get you signing!',
            signupButtonText: 'CREATE A HELLOSIGN ACCOUNT',
            signupButtonUrl: this.props.homeUrl,
            secondButtonText: 'SEE PRO PLANS',
            secondButtonUrl: this.props.pricingUrl
        };
        return React.createElement(CTASection, _extends({}, ctaSectionProps, this.props));
    },
    render: function render() {
        return React.createElement(
            'div',
            null,
            this.renderTitleSection(),
            this.renderBodySection(),
            this.renderCTASection()
        );
    }
});


/*****************
 ** WEBPACK FOOTER
 ** ./src/landing-pages/components/seo/free-esignature-tool.jsx
 ** module id = 1220
 ** module chunks = 0
 **/